import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-full_screen",
  "use": "icon-full_screen-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-full_screen\">\n<path d=\"M1 7.5V2C1 1.44772 1.44772 1 2 1H7.5\" stroke=\"#F3F3F3\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M15.5 9V14.5C15.5 15.0523 15.0523 15.5 14.5 15.5H9\" stroke=\"#F3F3F3\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol